import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ModalController, RadioGroupChangeEventDetail } from '@ionic/angular';
import { forkJoin } from 'rxjs';
import { VariableService } from 'src/app/services/variable.service';

@Component({
  selector: 'app-modal-payment-method',
  templateUrl: './modal-payment-method.component.html',
  styleUrls: ['./modal-payment-method.component.scss'],
})
export class ModalPaymentMethodComponent implements OnInit {
  selectedPaymentMethod: string;
  manual_text: SafeHtml;
  midtrans_text: SafeHtml;

  constructor(
    private modalCtrl: ModalController,
    private variableService: VariableService,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
    const manualVar = this.variableService.findVariable('manual_payment_text');
    const midtransVar = this.variableService.findVariable('online_payment_text');
    forkJoin([manualVar, midtransVar]).subscribe({
      next: ([manualRes, midtransRes]) => {
        this.manual_text = this.sanitizer.bypassSecurityTrustHtml(manualRes.value);
        this.midtrans_text = this.sanitizer.bypassSecurityTrustHtml(midtransRes.value);
      },
      complete: () => {
        // event?.target?.complete();
        // this.controllerService.dismissLoading();
      },
    });
  }

  onSelectPayment(event: Event) {
    const customEvent = event as CustomEvent<RadioGroupChangeEventDetail>;
    this.selectedPaymentMethod = customEvent.detail.value;
  }

  confirmPaymentMethod() {
    return this.modalCtrl.dismiss(this.selectedPaymentMethod, 'confirm');
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }
}
